module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "western4",
    attrs: {
      "id": "calibre_pb_8"
    }
  }, [_c('a', {
    attrs: {
      "id": "Ack_1"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c5"
  }, [_c('a', {
    attrs: {
      "href": "#/tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_007#ref_TOC"
    }
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("This didn’t start out as a novel. It was an exercise\nin teaching preparedness by storytelling a what-if situation on a\nday to day basis on a blog. As I got further into it, it morphed\ninto what it is now. There are so many to thank for their\nencouragement while I was writing this:")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("The gals in my Women’s Survival group, who\npushed me for that next entry yet understood when I needed a\nbreak;")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("To my sister, Pam, who let me bounce ideas\noff her and nagged me to publish;")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("And definitely a deep thank you to Jim Cobb,\nmy partner in crime on SurvivalWeekly.com— which the blog called\nhome— who helped me find a publisher willing to take the risk on\nme.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-424d4bac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_009.vue
// module id = 87
// module chunks = 0